export { default } from './SIMCardManual.container';
export { default as SIMCardManual } from './SIMCardManual';
